module.exports = "{{ status }}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/widget-status/widget-status.component.html
// module id = ./src/app/shared/widget-status/widget-status.component.html
// module chunks = main